import Splide from '@splidejs/splide'
// ===================================================
// $SLIDERS
// ===================================================

const sliders = {}

function stopAutoplayOnInteraction(splide) {
  const stop = () => splide.Components.Autoplay.pause()
  splide.on('drag', stop)
  splide.root.addEventListener('click', stop, { once: true })
}

// --- hero ---

const heroEl = document.querySelector('#hero-slider')
if (heroEl) {
  sliders.hero = new Splide(heroEl, {
    type: 'loop',
    perPage: 1,
    autoplay: true,
    pagination: true,
    arrows: false,
  }).mount()
  stopAutoplayOnInteraction(sliders.hero)
}

// --- reassurance ---

const reassuranceEl = document.querySelector('#reassurance .splide')
if (reassuranceEl) {
  sliders.reassurance = new Splide(reassuranceEl, {
    type: 'loop',
    autoplay: true,
    arrows: false,
    focus: 0,
    omitEnd: true,
  })

  sliders.reassurance.on('overflow', function (isOverflow) {
    sliders.reassurance.options = {
      pagination: isOverflow,
      drag: isOverflow,
    }
  })

  sliders.reassurance.mount()
  stopAutoplayOnInteraction(sliders.reassurance)
}

// --- product gallery on mobile ---

const productGalleryEl = document.querySelector('#product-gallery')
if (productGalleryEl) {
  var bar = document.querySelector('#product-gallery .progress-bar span')
  sliders.productGallery = new Splide(productGalleryEl, {
    arrows: false,
    pagination: false,
    drag: 'free',
    snap: true,
    releaseWheel: true,
    mediaQuery: 'min',
    breakpoints: {
      480: {
        perPage: 2,
      },
      767: {
        destroy: true,
      },
    },
  })

  sliders.productGallery.on('mounted moved dragged scrolled', function () {
    var end = sliders.productGallery.Components.Controller.getEnd() + 1
    var rate = Math.min((sliders.productGallery.index + 1) / end, 1)
    bar.style.width = String(100 * rate) + '%'
  })

  sliders.productGallery.mount()
}

// --- categories list on products listing page ---

const categoriesListEl = document.querySelector('#products-categories')
if (categoriesListEl) {
  sliders.categoriesList = new Splide(categoriesListEl, {
    arrows: false,
    width: '100%',
    autoWidth: true,
    pagination: false,
    drag: 'free',
  })

  sliders.categoriesList.on('overflow', function (isOverflow) {
    if (isOverflow == false) {
      //alert(isOverflow);
      sliders.categoriesList.options = {
        destroy: 'completely',
      }
    }
  })

  sliders.categoriesList.mount()
}

// --- selected products ---

window.addEventListener('load', () => {
  document.querySelectorAll('.selected-products .splide').forEach((el) => {
    let maxHeight = 0
    el.querySelectorAll('.splide__slide .card-content').forEach((slide) => {
      maxHeight = Math.max(maxHeight, slide.offsetHeight + 318)
    })
    //alert(maxHeight);

    new Splide(el, {
      type: 'loop',
      autoWidth: true,
      height: maxHeight,
      pagination: false,
      arrows: true,
      gap: '1.25rem',
      focus: 0,
      omitEnd: true,
    }).mount()
  })
})

// --- cold content slider ---

const coldEditorialContentEl = document.querySelector('#cold-content-slider')
if (coldEditorialContentEl) {
  sliders.coldEditorialContent = new Splide(coldEditorialContentEl, {
    type: 'fade',
    rewind: true,
    perPage: 1,
    autoplay: true,
  })

  sliders.coldEditorialContent.on('active', function () {
    var slide =
      sliders.coldEditorialContent.Components.Elements.slides[
        sliders.coldEditorialContent.index
      ]
    sliders.coldEditorialContent.Components.Elements.track.style.height =
      slide.offsetHeight + 'px'
  })

  sliders.coldEditorialContent.mount()
  stopAutoplayOnInteraction(sliders.coldEditorialContent)

  window.addEventListener(
    'load',
    function () {
      sliders.coldEditorialContent.Components.Elements.track.style.height =
        sliders.coldEditorialContent.Components.Elements.slides[0]
          .offsetHeight + 'px'
    },
    { once: true }
  )

  const sliderNavItems = document.querySelectorAll(
    '#cold-content-introslider .slider-nav li'
  )
  if (sliderNavItems.length) {
    sliderNavItems[0].querySelector('button').classList.add('active')

    sliderNavItems.forEach(function (item, index) {
      item.querySelector('button').addEventListener('click', function () {
        sliders.coldEditorialContent.go(index)
        sliders.coldEditorialContent.Components.Autoplay.pause()
      })
    })

    sliders.coldEditorialContent.on('active', function () {
      sliderNavItems.forEach(function (item) {
        item.querySelector('button').classList.remove('active')
      })
      sliderNavItems[sliders.coldEditorialContent.index]
        .querySelector('button')
        .classList.add('active')
    })
  }
}
